import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

 
@Component({
    selector: 'app-externalsite-alert',
    templateUrl: './externalsite-alert.component.html',
    standalone: false
})
export class ExternalsiteAlertComponent implements OnInit {
   
  @Input() public eventReference;
  constructor(
    private readonly modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }
  redirectto(){
    window.open(this.eventReference);
    this.modalService.dismissAll();
  }
  dismissModal(){
    this.modalService.dismissAll();
  }
}